import config from './url-directory';
import fisConfig from './fis-url-directory';
import _ from 'lodash';
import store from '../redux/configure-store';

const isLocalhost = window && window.location.hostname.toLowerCase().indexOf('localhost.troweprice.com') !== -1;

export function getEnvironment() {
  const appConfig = store.getState().appConfig;
  const { environment } = appConfig;
  return _.upperCase(environment);
}

export function getInternalOrExternalDomain() {
  const domain = window.location.hostname.toLowerCase().indexOf('.awstrp.net') !== -1 ? 'INTERNAL' : 'EXTERNAL';
  return domain;
}

export const isInternal = () => {
  return getInternalOrExternalDomain() === 'INTERNAL' ? true : false;
}

export function isAEMAuthor ()  {
  const domain = window.location.href.toLowerCase().indexOf('localhost.troweprice.com:4502') !== -1 || window.location.hostname.toLowerCase().indexOf('author') !== -1;
  return domain;
}

export function isMobileApp () {
  const urlParams = new URLSearchParams(window.location.search);
  const isMobileApp = urlParams.get('mobile-app') === 'true';
  return isMobileApp;
}

export function isTouchDevice () {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

export function getApiKey() {
  const appConfig = store.getState().appConfig;
  console.log('appConfig', 'store', appConfig, store);
  const { apiKey, apiKeyFIS } = appConfig;
  return apiKeyFIS;
}

export function getApiKeyFIS() {
  if(isLocalhost ()){
    return ''
  }
  const appConfig = store.getState().appConfig;
  console.log('appConfig', 'store', appConfig, store, 'entering?');
  const { apiKeyFIS } = appConfig;
  return apiKeyFIS;
}

export function getDomain() {
  const envObject = config[getEnvironment()];
  return envObject && envObject[getInternalOrExternalDomain()]['web'];
}

export function getApiDomain() {
  const envObject = config[getEnvironment()];
  return envObject && envObject[getInternalOrExternalDomain()]['api'];
}

export function getFISApiDomain() {
  const envObject = fisConfig[getEnvironment()];
  return envObject && envObject[getInternalOrExternalDomain()]['api'];
}

export const getOptionsObject = url => (
  console.log('url', url, getApiDomain, getFISApiDomain),
  {
  url: getFISApiDomain() + url,
  method: 'GET',
  crossDomain: true,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'x-trp-requested-with': 'XMLHttpRequest',
    apiKey: getApiKey(),
    Accept: '*/*',
  },
});

export const getOptionsObjectWithApiKey = (url, apiKey) => (
  {

    url: getFISApiDomain() + url,
    method: 'GET',
    crossDomain: true,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'x-trp-requested-with': 'XMLHttpRequest',
      apiKey: apiKey,
      Accept: '*/*',
    },
  });

export const getRpsDistroAppApiKey = function() {
    return document.getElementById('fisDpsAppApiKey')?.getAttribute('data-fisDpsAppApiKey');
}

export const getPlanNumber = function (){
  let param = new URLSearchParams(window.location.search);
  let urlAccountKey = param.get("accountKey");
  let planNumber;
  if (localStorage.getItem("planNumber") && localStorage.getItem("planNumber") !== 'undefined') {
    planNumber = localStorage.getItem("planNumber");
  } else if (urlAccountKey) {
    planNumber = urlAccountKey.split("RPS_")[1];
    localStorage.setItem("planNumber", planNumber)
  }
  return planNumber;
}

export const getPostOptionsObject = (url, body) => {
  if(body) {
    return {
      ...getOptionsObject(url),
      method: 'POST',
      body,
    }
  }
  return {
    ...getOptionsObject(url),
    method: 'POST',
  }  
};

export const getDeleteOptionsObject = url => ({
  ...getOptionsObject(url),
  method: 'DELETE',
});
